import styled, { css } from 'styled-components';

import { colors, monokaiBackground } from 'global/colors';

export const ApiContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;

  ${({ isDarkMode }) =>
    isDarkMode &&
    css`
      background-color: ${monokaiBackground};
    `};
`;

export const ApiMethodHeader = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  gap: 5px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 5px 7px 5px 7px;
  color: ${colors.white};
  background-color: ${colors.fsDarkBlue};
  border-bottom: 1px solid ${colors.fsDarkBlueHoverDark};

  &:hover {
    background-color: ${colors.fsDarkBlueHoverDark};
  }
`;

export const DeleteIcon = styled.i.attrs({ className: 'fa fa-trash' })`
  color: ${colors.white};
  margin-right: 10px;
`;

export const PlusIcon = styled.i.attrs({ className: 'fa fa-plus' })``;

export const ApiModalInput = styled.input`
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  color: ${colors.darkGray};
  border: 1px solid ${colors.borderGray};
  border-radius: 0.25rem;
  &:focus {
    outline: 0;
  }
  ${({ marginTop }) =>
    marginTop &&
    css`
      margin-top: 0.75rem;
    `}
`;

export const ApiDescriptionInput = styled.textarea`
  display: block;
  width: 100%;
  height: calc(6em + 0.75rem + 2px);
  margin-top: 0.75rem;
  padding: 0.375rem 0.75rem;
  color: ${colors.darkGray};
  border: 1px solid ${colors.borderGray};
  border-radius: 0.25rem;
  &:focus {
    outline: 0;
  }
`;

export const ApiTypeSelect = styled.select`
  outline: 0 none !important;
  box-shadow: none !important;
  padding: 0.7em;
  padding: 0.375rem 0.75rem;
  color: ${colors.darkGray};
  border-radius: 0.3rem;
  border: 1px solid ${colors.borderGray};
`;

export const ApiModalLabel = styled.label`
  display: block;
  margin-top: 1rem;
`;

export const ApiParametersRow = styled.div.attrs({ className: 'row' })`
  ${({ marginBottom = '0.5rem' }) =>
    css`
      margin-bottom: ${marginBottom};
    `}
  max-width: 100%;
`;

export const ApiParameterCol = styled.div.attrs(({ col = 'col-6' }) => ({ className: col }))`
  margin-bottom: 0.5rem;
`;

export const ApiParameterChildContainer = styled.div`
  margin-top: 0.5rem;
  margin-left: 1rem;
`;

export const ApiParameterDeleteContainer = styled.div.attrs({ className: 'col-1' })`
  line-height: 2.5;
  & i {
    cursor: pointer;
    color: ${colors.darkGray};
  }
`;

export const ApiParameterLabel = styled.label`
  margin-right: 0.5rem;
  margin-bottom: 0.25rem;
`;

export const ErrorMessage = styled.p`
  color: ${colors.red};
  font-size: 12px;
  padding: 0.25rem;
  ${({ noMarginBottom }) =>
    noMarginBottom &&
    css`
      margin-bottom: 0;
    `}
`;
